import React from "react";

export default function Header() {
  return (
    <header className="app-header">
      <div className="header-inner">
        <h1>🌐 TechThings IoT Dashboard</h1>
        <p>Monitoramento em tempo real dos dispositivos ESP32</p>
      </div>
    </header>
  );
}
